export const FEATURE_NEW_FILTERING = "AbFiltering";
export const FEATURE_GAME_RECOMMENDATIONS = 'GameRecommendations';
export const FEATURE_ROUTE_OVERWRITE = "AbRouteOverwrite";
export const FEATURE_DEPOSIT_WIDGET = "DepositWidget"; //used only on backend side
export const FEATURE_CASHOUT_WIDGET = "CashoutWidget"; //used only on backend side
export const FEATURE_NAME_SAFE_ZONE_TOGGLE = "AbTestingSafeZoneToggle";
export const FEATURE_NAME_LIST_ON_TOP = "ListOnTop";
export const FEATURE_NAME_PARTY_JACKPOTS = "PartyJackpots";
export const FEATURE_NAME_GRAPHYTE_LISTS = "AbGraphyteLists";
export const FEATURE_NAME_TOP_BANNER_REDESIGN = "AbTopBannerRedesign";
export const FEATURE_NAME_SEARCH_GAME_SUGGESTED_BY_AI = "SearchGameSuggestionByAI";
export const FEATURE_NAME_PLAYERS_LIKE_YOU_GAMES_LIST_TYPE_ID = "PlayersLikeYouGamesListTypeId";
export const FEATURE_NAME_VIDEO_LIVE_STREAM = "LiveStreamEnabled";
export const FEATURE_NAME_AI_SORT_GAME_LIST = "AbTestingAiSortGamesLists";
export const FEATURE_NAME_EXIT_POPUP_SQUARE_ICON = "ExitPopupSquareIconEnabled";
export const FEATURE_NAME_BECAUSE_YOU_PLAYED_LIST = "BecauseYouPlayedListEnabled";
export const FEATURE_NAME_ANIMATED_GAME_ICONS = "AbTestingAnimatedIcons";
